<!-- eslint-disable -->
<template lang="pug">
    .multiplayer-game-menu__selectors
        cs-button.selector(
            :narrow="true",
            color="blue",
            pattern="primary-outline",
            :disabled="gameState === 'started'",
            @click.native="handleModalState",
        ) {{ $i18n.t('support.support_createTicket_theme') }}
        cs-multiselect.selector.speeds-selector(
            :options="seconds",
            v-model='selectedSpeed',
            :custom-label="secondsLabel",
            :placeholder="secondsLabel(selectedSpeed)",
            :multiple="false",
            :allow-empty="false",
            :hide-selected="true",
            :disabled="gameState === 'started'"
        )
            span(slot="inner-label")
                | {{ $i18n.t('trainer.trainer_gameFormSetting_showTimeNumbers') }}:
                |
        cs-multiselect.selector.series-amount-selector(
            :options="amountsOfSeries",
            v-model='selectedAmountOfSeries',
            :placeholder="$i18n.t('trainer.trainer_gameFormSetting_numOfSeries')",
            :multiple="false",
            :allow-empty="false",
            :show-labels="false",
            :searchable="false",
            :close-on-select="true",
            :disabled="gameState === 'started'"
        )
            span(slot="inner-label")
                | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfSeries') }}:
                |
        cs-multiselect.selector.numbers-amount-selector(
            :options="numbersAmounts",
            v-model='selectedAmountOfNumbers',
            :placeholder="$i18n.t('trainer.trainer_gameFormSetting_amountOfNumbers')",
            :multiple="false",
            :allow-empty="false",
            :show-labels="false",
            :searchable="false",
            :close-on-select="true",
            :disabled="gameState === 'started'"
        )
            span(slot="inner-label")
                | {{ numbersAmountInnerLabel }}:
                |
        cs-multiselect.selector.infinite-amount-of-examples(
            :options="infiniteOptions",
            v-model='selectedInfiniteAmountOfExamplesStatus',
            :placeholder="$i18n.t('trainer.trainer_gameFormSetting_infiniteAmountOfExamples')",
            :multiple="false",
            :allow-empty="false",
            :show-labels="false",
            :searchable="false",
            :close-on-select="true",
            label="label",
            :disabled="gameState === 'started' || !!selectedAmountOfSeries"
        )
            span(slot="inner-label")
                | {{ $i18n.t('trainer.trainer_gameFormSetting_infiniteAmountOfExamples') }}:
                |
        cs-multiselect.selector.players-selector(
            :multiple="false",
            :show-labels="false",
            :searchable="false",
            :close-on-select="true",
            :allow-empty="false",
            v-model="playersAmount",
            :options="players",
            :disabled="gameState === 'started'"
        )
            span(slot="inner-label")
                | {{ $i18n.t('trainer.trainer_gameSetting_players') }}:
                |
        cs-modal(
            v-if="isModalOpened",
            @close="handleModalClose",
            :is-for-multiplayer-settings="true"
        )
            .modal-header(slot="header") {{ $i18n.t('support.support_createTicket_theme') }}
            .modal-content
                .modal-content__units-label {{ "0-9" }}
                .flash-cards-units
                    settings-tab.settings-tab(
                        v-for="number in 9",
                        :selected="selectedDifficult.digits && !!selectedDifficult.digits[number - 1]",
                        :disabled="false",
                        @select="setDifficult('digits', number)",
                        :key="number",
                    ) {{ number }}
                .flash-cards-digits
                    settings-tab.settings-tab.setting-tab__digit(
                        v-for="difficult in difficulties",
                        :key="difficult.key",
                        :selected="selectedDifficult[difficult.key]",
                        @click.native="setDifficult(difficult.key, true)"
                    ) {{ difficult.name }}
            .modal-footer(slot="footer")
                cs-button.reset-button(
                    color="blue",
                    pattern="primary-outline",
                    @click.native="resetDifficult"
                ) {{ $i18n.t('trainer.trainer_gameFormSetting_resetSettings') }}
                cs-button.save-button(
                    color="blue",
                    @click.native="saveDifficult"
                ) {{ $i18n.t('trainer.trainer_gameFormSetting_saveChanges') }}
</template>

<script>
    /*eslint-disable*/
    import MultiplayerOptionsMixin from "../../../utils/multiplayer/optionsMixin";
    import FlashCardsConfig from "../../trainer/configs/FlashCardsConfig";
    import { cloneDeep, values } from 'lodash';

    const COMMON_PARAMETERS_CHANGED_EVENT = 'commonParametersHasChanged';
    const SPEED_PARAMETER = 'speed';
    const SERIES_PARAMETER = 'isSeries';
    const SERIES_AMOUNT_PARAMETER = 'seriesAmount';
    const SERIES_NUMBERS_AMOUNT_PARAMETER = 'seriesExamples';
    const DEFAULT_NUMBERS_AMOUNT_PARAMETER = 'amount';
    const INFINITE_AMOUNT_OF_EXAMPLES_PARAMETER = 'infinityAmountOfExamples';
    const PLAYING_STATE = 'started';

    export default {
        mounted () {
            this.selectedSpeed = this.commonParams.speed;
            if (this.commonParams.isSeries) {
                this.selectedAmountOfSeries = this.commonParams.seriesAmount;
                this.selectedAmountOfNumbers = this.commonParams.seriesExamples;
            } else {
                this.selectedAmountOfNumbers = this.commonParams.amount;
            }
            this.selectedDifficult = cloneDeep(this.commonParams.difficult);
            this.selectedInfiniteAmountOfExamplesStatus = this.infiniteOptions.find(option => option.status === this.commonParams.infinityAmountOfExamples);
        },
        mixins: [MultiplayerOptionsMixin],
        watch: {
            selectedSpeed: {
                handler (value, oldValue) {
                    if (oldValue !== 0) {
                        this.commonParams.speed = value;
                        this.$emit(COMMON_PARAMETERS_CHANGED_EVENT, {name: SPEED_PARAMETER, value: value});
                    }
                }
            },
            selectedAmountOfSeries: {
                handler (value, oldValue) {
                    this.commonParams.isSeries = value !== 0;
                    this.commonParams.seriesAmount = value;
                    this.selectedInfiniteAmountOfExamplesStatus = this.infiniteOptions.find(option => option.status === !this.commonParams.isSeries);
                    this.$emit(COMMON_PARAMETERS_CHANGED_EVENT, {
                        setSeries: true,
                        names: [SERIES_PARAMETER, SERIES_AMOUNT_PARAMETER],
                        values: [this.commonParams.isSeries, this.commonParams.seriesAmount]
                    });
                }
            },
            selectedAmountOfNumbers: {
                handler (value, oldValue) {
                    if (oldValue !== 0) {
                        let parameterName = this.commonParams.isSeries
                            ? SERIES_NUMBERS_AMOUNT_PARAMETER
                            : DEFAULT_NUMBERS_AMOUNT_PARAMETER;
                        this.commonParams[parameterName] = value;
                        this.selectedInfiniteAmountOfExamplesStatus = this.infiniteOptions.find(option => !option.status);
                        this.$emit(COMMON_PARAMETERS_CHANGED_EVENT, {name: parameterName, value: value});
                    }
                }
            },
            'commonParams.isSeries': {
                handler (value, oldValue) {
                    if (oldValue !== undefined) {
                        let parameterName = value
                            ? SERIES_NUMBERS_AMOUNT_PARAMETER
                            : DEFAULT_NUMBERS_AMOUNT_PARAMETER;
                        this.commonParams[parameterName] = this.selectedAmountOfNumbers;
                        this.$emit(COMMON_PARAMETERS_CHANGED_EVENT, {name: parameterName, value: this.selectedAmountOfNumbers});
                    }
                }
            },
            'selectedDifficult.digits': {
                handler (val) {
                    if (val && val.length === 0) {
                        this.selectedDifficult.digits = null;
                    }
                }
            },
            selectedInfiniteAmountOfExamplesStatus: {
                handler (value, oldValue) {
                    if (oldValue !== null) {
                        this.commonParams.infinityAmountOfExamples = value.status;
                        this.$emit(COMMON_PARAMETERS_CHANGED_EVENT, {
                            name: INFINITE_AMOUNT_OF_EXAMPLES_PARAMETER,
                            value: value.status
                        });
                    }
                }
            }
        },
        data () {
            return {
                selectedSpeed: 0,
                seconds: FlashCardsConfig.seconds,
                selectedAmountOfSeries: 0,
                amountsOfSeries: [...Array(21).keys()],
                selectedAmountOfNumbers: 0,
                selectedDifficult: null,
                digits: [1, 2, 3, 4, 5, 6, 7, 8, 9],
                difficulties: [
                    {
                        name: `${this.$i18n.t('trainer.trainer_gameFormSetting_tenners')} 10-90`,
                        key: 'tens',
                    },
                    {
                        name: `${this.$i18n.t('trainer.trainer_gameFormSetting_doubleDigits')} 10-19`,
                        key: 'teens',
                    },
                    {
                        name: `${this.$i18n.t('trainer.trainer_gameFormSetting_doubleDigits')} 10-99`,
                        key: 'twoDigit',
                    },
                    {
                        name: `${this.$i18n.t('trainer.trainer_gameFormSetting_tripleHundreds')} 100-900`,
                        key: 'hundreds',
                    },
                    {
                        name: `${this.$i18n.t('trainer.trainer_gameFormSetting_tripleDigits')} 100-999`,
                        key: 'threeDigit',
                    },
                    {
                        name: `${this.$i18n.t('trainer.trainer_gameFormSetting_fourThousands')} 1000-9000`,
                        key: 'thousands',
                    },
                    {
                        name: `${this.$i18n.t('trainer.trainer_gameFormSetting_fourDigits')} 1000-9999`,
                        key: 'fourDigit',
                    },
                    {
                        name: `${this.$i18n.t('trainer.trainer_gameFormSetting_fiveDigits')} 10000-99999`,
                        key: 'fiveDigit',
                    }
                ],
                isModalOpened: false,
                infiniteOptions: [
                    {
                        status: true,
                        label: this.$i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated'),
                    },
                    {
                        status: false,
                        label: this.$i18n.t('trainer.trainer_gameFormSettingValue_offAbbreviated'),
                    }
                ],
                selectedInfiniteAmountOfExamplesStatus: null,
            }
        },
        methods: {
            secondsLabel (amount) {
                return amount + ' ' + this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds');
            },
            handleModalState () {
                this.isModalOpened = !this.isModalOpened;
            },
            handleModalClose () {
                this.selectedDifficult = cloneDeep(this.commonParams.difficult);
                this.isModalOpened = false;
            },
            setDifficult (key, value) {
                if (this.selectedDifficult[key] === value) {
                    this.selectedDifficult[key] = false;
                } else if (
                    this.selectedDifficult[key]
                    && this.selectedDifficult[key][this.selectedDifficult[key].length - 1] === value
                ) {
                    this.selectedDifficult[key] = this.selectedDifficult[key].slice(0, this.selectedDifficult[key].length - 1);
                } else {
                    Object.assign(this.selectedDifficult, {
                        teens: false,
                        twoDigit: false,
                        threeDigit: false,
                        fourDigit: false,
                        fiveDigit: false
                    });
                    if (key === 'digits') {
                        this.selectedDifficult.digits = this.digits.slice(0, value);
                    } else if (key !== 'tens' && key !== 'hundreds' && key !== 'thousands') {
                        this.selectedDifficult[key] = value;
                        this.selectedDifficult.digits = null;
                        this.selectedDifficult.tens = false;
                        this.selectedDifficult.hundreds = false;
                        this.selectedDifficult.thousands = false;
                    } else if (key === 'tens') {
                        this.selectedDifficult[key] = value;
                        this.selectedDifficult.hundreds = false;
                        this.selectedDifficult.thousands = false;
                    } else if (key === 'hundreds') {
                        this.selectedDifficult[key] = value;
                        this.selectedDifficult.tens = false;
                        this.selectedDifficult.thousands = false;
                    } else {
                        this.selectedDifficult[key] = value;
                        this.selectedDifficult.hundreds = false;
                        this.selectedDifficult.tens = false;
                    }
                }
            },
            resetDifficult () {
                this.difficulties.forEach(digit => {
                    this.commonParams.difficult[digit.key] = false;
                    this.commonParams.difficult.digits = this.digits.slice(0);
                });
                this.$emit(COMMON_PARAMETERS_CHANGED_EVENT, {name: 'difficult', value: this.commonParams.difficult});
            },
            saveDifficult () {
                if (this.gameState !== PLAYING_STATE) {
                    if (
                        this.selectedDifficult
                        && typeof(this.selectedDifficult) === 'object'
                        && (this.selectedDifficult.tens || this.selectedDifficult.hundreds || this.selectedDifficult.thousands)
                    ) {
                        if (this.selectedDifficult.digits) {
                            if (this.selectedDifficult.digits.length === 1) {
                                this.$toasted.error(this.$i18n.t('errors.incorrect_number_selected'));
                                return;
                            }
                        } else {
                            this.$toasted.error(this.$i18n.t('errors.select_number_between'));
                            return;
                        }
                    } else if (!values(this.selectedDifficult).filter(el => el).length) {
                        this.$toasted.error(this.$i18n.t('errors.select_at_least_one_option'));
                        return;
                    }
                    this.commonParams.difficult = this.selectedDifficult;
                    this.$emit(COMMON_PARAMETERS_CHANGED_EVENT, {name: 'difficult', value: this.commonParams.difficult});
                }
                this.isModalOpened = false;
            }
        },
        computed: {
            numbersAmounts () {
                let amountOfNumbers = this.commonParams && this.commonParams.isSeries ? 10 : 101;
                return [...Array(amountOfNumbers).keys()].slice(1);
            },
            numbersAmountInnerLabel () {
                if (this.commonParams && this.commonParams.isSeries) {
                    return this.$i18n.t('trainer.trainer_gameFormSetting_numsInSeries');
                }
                return this.$i18n.t('trainer.trainer_gameFormSetting_amountOfNumbers');
            }
        }
    }
</script>

<style scoped lang="scss">
    .multiplayer-game-menu__selectors {
        display: flex;
        width: 80%;
        margin: 20px;
    }
    .selector {
        margin: 0 10px;
        max-height: 44px;
        &:first-child {
            margin-left: 0;
        }
        @media screen and (max-width: 1439px) {
            max-width: 155px;
        }
    }
    .modal-footer {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 30px;
    }
    .reset-button {
        margin-right: 20px;
    }
    .modal-content {
        margin-top: 25px;
        max-width: 578px;
    }
    .modal-content__units-label {
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        color: $x-color-black;
        margin-bottom: 10px;
        text-align: left;
    }
    .flash-cards-units {
        display: flex;
        margin-bottom: 10px;
    }
    .flash-cards-digits {
        display: flex;
        flex-wrap: wrap;
    }
    .settings-tab {
        margin-right: 10px;
    }
    .setting-tab__digit {
        margin-top: 10px;
    }
    .infinite-amount-of-examples {
        @media screen and (min-width: 1500px) {
            min-width: 330px;
        }
    }
</style>